var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333H10.0083",
    stroke: "#364153",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 13.3333H13.3418",
    stroke: "#364153",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V7.08333C17.5001 7.00858 17.48 6.93519 17.442 6.87085C17.404 6.8065 17.3493 6.75357 17.2838 6.71761C17.2183 6.68165 17.1443 6.66398 17.0696 6.66645C16.9948 6.66893 16.9222 6.69145 16.8592 6.73167L13.1408 9.10167C13.0778 9.14188 13.0052 9.16441 12.9304 9.16688C12.8557 9.16935 12.7817 9.15168 12.7162 9.11572C12.6507 9.07976 12.596 9.02683 12.558 8.96249C12.52 8.89814 12.4999 8.82475 12.5 8.75V7.08333C12.5001 7.00858 12.48 6.93519 12.442 6.87085C12.404 6.8065 12.3493 6.75357 12.2838 6.71761C12.2183 6.68165 12.1443 6.66398 12.0696 6.66645C11.9948 6.66893 11.9222 6.69145 11.8592 6.73167L8.14167 9.10167C8.07864 9.1421 8.00589 9.1648 7.93106 9.16739C7.85622 9.16998 7.78208 9.15235 7.71641 9.11636C7.65075 9.08038 7.596 9.02736 7.55791 8.96289C7.51983 8.89842 7.49982 8.82488 7.5 8.75V4.16667C7.5 3.72464 7.3244 3.30072 7.01184 2.98816C6.69928 2.67559 6.27536 2.5 5.83333 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V15.8333Z",
    stroke: "#364153",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 13.3333H6.67484",
    stroke: "#364153",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.c26887135b05b83ceea726634e988ba0.svg";
export { ForwardRef as ReactComponent };